'use es6';

import styled from 'styled-components';
const FilterTag = styled.span.withConfig({
  displayName: "FilterTag",
  componentId: "vacuih-0"
})(["span:hover{text-decoration:underline;}"]);
export default FilterTag;